import { getData, getElement, tabs } from "../../../../../../helpers";
import { Dt } from "../../../../../../plugins/datatable";
import { RiskModal } from "../../modals/risk";
import { TagCustomer } from "../../modals/tag";
import { TaxCustomer } from "../../modals/tax";
import { BankModal as Bank } from "../../../../../settings/settings/banks/modals/store";
import { AttachProject } from "../../../../../settings/settings/projects/modals/attach";

class TabDataCustomer extends HTMLDivElement {
    connectedCallback() {
        this.addEvents();
        this.banks();
        this.risk();
        this.addresses();
        this.tags();
        this.projects();
        this.taxes();
    }

    addEvents() {
        this.addEventListener("click", (e) => {
            const BtnAddBank = e.target.closest("[name=btnAddBank]");
            const BtnEditBank = e.target.closest("[name=btnEditBank]");
            const BtnAddRisk = e.target.closest("[name=btnAddRisk]");
            const BtnEditRisk = e.target.closest("[name=btnEditRisk]");
            const Tab = e.target.closest("[data-bs-toggle=pill]");
            const BtnAddTag = e.target.closest("[name=btnAddTag]");
            const BtnEditTag = e.target.closest("[name=btnEditTag]");
            const BtnAddProject = e.target.closest("[name=btnAddProject]");
            const BtnEditProject = e.target.closest("[name=btnEditProject]");
            const BtnAddTax = e.target.closest("[name=btnAddTax]");
            const BtnEditTax = e.target.closest("[name=btnEditTax]");

            // Agregar Banco
            if (BtnAddBank) {
                Bank.create(
                    getData(BtnAddBank, "data-bs-target"),
                    getData(BtnAddBank, "title"),
                    getData(BtnAddBank, "data-url")
                );
            }

            // Editar Banco
            if (BtnEditBank) {
                Bank.edit(
                    getData(BtnEditBank, "data-bs-target"),
                    getData(BtnEditBank, "title"),
                    getData(BtnEditBank, "data-url"),
                    getData(BtnEditBank, "data-data")
                );
            }

            // Recordar Tab
            if (Tab) {
                tabs(Tab);
            }

            // Agregar Banco
            if (BtnAddRisk) {
                RiskModal.create(
                    getData(BtnAddRisk, "data-bs-target"),
                    getData(BtnAddRisk, "title"),
                    getData(BtnAddRisk, "data-url")
                );
            }

            // Editar Banco
            if (BtnEditRisk) {
                RiskModal.edit(
                    getData(BtnEditRisk, "data-bs-target"),
                    getData(BtnEditRisk, "title"),
                    getData(BtnEditRisk, "data-url"),
                    getData(BtnEditRisk, "data-data")
                );
            }

            // Agregar Etiqueta
            if (BtnAddTag) {
                TagCustomer.create(
                    getData(BtnAddTag, "data-bs-target"),
                    getData(BtnAddTag, "title"),
                    getData(BtnAddTag, "data-url")
                );
            }

            // Editar Etiqueta
            if (BtnEditTag) {
                TagCustomer.edit(
                    getData(BtnEditTag, "data-bs-target"),
                    getData(BtnEditTag, "title"),
                    getData(BtnEditTag, "data-url"),
                    getData(BtnEditTag, "data-data")
                );
            }

            // Agregar Etiqueta
            if (BtnAddProject) {
                AttachProject.create(
                    getData(BtnAddProject, "data-bs-target"),
                    getData(BtnAddProject, "title"),
                    getData(BtnAddProject, "data-url")
                );
            }

            // Editar Etiqueta
            if (BtnEditProject) {
                AttachProject.edit(
                    getData(BtnEditProject, "data-bs-target"),
                    getData(BtnEditProject, "title"),
                    getData(BtnEditProject, "data-url"),
                    getData(BtnEditProject, "data-data")
                );
            }

            // Agregar Impuesto
            if (BtnAddTax) {
                TaxCustomer.create(
                    getData(BtnAddTax, "data-bs-target"),
                    getData(BtnAddTax, "title"),
                    getData(BtnAddTax, "data-url")
                );
            }

            // Editar Impuesto
            if (BtnEditTax) {
                TaxCustomer.edit(
                    getData(BtnEditTax, "data-bs-target"),
                    getData(BtnEditTax, "title"),
                    getData(BtnEditTax, "data-url"),
                    getData(BtnEditTax, "data-data")
                );
            }
        });
    }

    banks() {
        const DtBanks = getElement("[data-table=dtBanks]", this);
        // Start DataTable
        let configDt = {
            pageLength: 4,
            lengthChange: false,
            ordering: false,
            columnDefs: [
                {
                    targets: [0, 6],
                    width: "5%",
                    className: "text-center",
                },
            ],
        };

        const DtB = new Dt(configDt);
        DtB.dataTable(DtBanks);
        // End DataTable
    }

    risk() {
        const DtRisk = getElement("[data-table=dtRisk]", this);

        // Start DataTable
        let configDt = {
            pageLength: 4,
            lengthChange: false,
            ordering: false,
            columnDefs: [
                {
                    targets: [0, 4],
                    width: "5%",
                    className: "text-center",
                },
                {
                    targets: [3],
                    width: "23%",
                },
            ],
        };

        const DtR = new Dt(configDt);
        DtR.dataTable(DtRisk);
        // End DataTable
    }

    addresses() {
        const DtAddresses = getElement("[data-table=dtAddresses]", this);

        // Start DataTable
        let configDt = {
            pageLength: 3,
            lengthChange: false,
            ordering: false,
            columnDefs: [
                {
                    targets: [0, 2, 3],
                    width: "5%",
                    className: "text-center",
                },
            ],
        };

        const DtA = new Dt(configDt);
        DtA.dataTable(DtAddresses);
        // End DataTable
    }

    tags() {
        const DtTags = getElement("[data-table=dtTags]", this);

        // Start DataTable
        let configDt = {
            pageLength: 4,
            lengthChange: false,
            ordering: false,
            columnDefs: [
                {
                    targets: [0, 2],
                    width: "5%",
                    className: "text-center",
                },
            ],
        };

        const DtTg = new Dt(configDt);
        DtTg.dataTable(DtTags);
        // End DataTable
    }

    projects() {
        const DtProjects = getElement("[data-table=dtProjects]", this);

        // Start DataTable
        let configDt = {
            pageLength: 4,
            lengthChange: false,
            ordering: false,
            columnDefs: [
                {
                    targets: [0, 2],
                    width: "5%",
                    className: "text-center",
                },
            ],
        };

        const DtTg = new Dt(configDt);
        DtTg.dataTable(DtProjects);
        // End DataTable
    }

    taxes() {
        const DtTaxes = getElement("[data-table=dtTaxes]", this);

        // Start DataTable
        let configDt = {
            pageLength: 4,
            lengthChange: false,
            ordering: false,
            columnDefs: [
                {
                    targets: [0, 3, 4, 5],
                    width: "5%",
                    className: "text-center",
                },
            ],
        };

        const DtT = new Dt(configDt);
        DtT.dataTable(DtTaxes);
        // End DataTable
    }
}

window.customElements.define("tabdata-customer", TabDataCustomer, {
    extends: "div",
});
